// Here you can install Vue plugins
export default () => ([]);
